import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actions from "./configActions";

function* fetchMycoreConfig() {
    try {
        const result = yield call(AxiosCall, '/mycore/config/get/');
        yield put(actions.fetchMycoreConfigSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchMycoreConfigFailure(e));
    }
}

function* updateMycoreConfig(action) {
    try {
        const { configData } = action.payload;
        const result = yield call(AxiosPost, '/mycore/config/update/', configData);
        yield put(actions.updateMycoreConfigSuccess(result.data));
    } catch (e) {
        yield put(actions.updateMycoreConfigFailure(e));
    }
}

function* resetMycoreConfig() {
    try {
        const result = yield call(AxiosPost, '/mycore/config/reset/', {});
        yield put(actions.resetMycoreConfigSuccess(result.data.config));
    } catch (e) {
        yield put(actions.resetMycoreConfigFailure(e));
    }
}

export default function* configSaga() {
    yield all([
        // Watchers
        takeLatest(actions.FETCH_MYCORE_CONFIG.REQUEST, fetchMycoreConfig),
        takeLatest(actions.UPDATE_MYCORE_CONFIG.REQUEST, updateMycoreConfig),
        takeLatest(actions.RESET_MYCORE_CONFIG.REQUEST, resetMycoreConfig),
    ]);
}
